import classNames from "classnames";
import styled from 'styled-components';

export const LiteTradeSelectAccountStyled = styled.div`
    height: 40px;
    border-radius: 16px;
    
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .dropdown-toggle {
        svg {
            color: var();
        }
    }
    
    &.min-width {
        min-width: 200px;
    }
`;

export const LiteTradeSelectAccountTitleStyled = styled.div`
    font-size: 16px;
    font-weight: 600;
`;

interface ILiteTradeSelectAccountItemStyledProps {
    selected: boolean
}

export const LiteTradeSelectAccountItemStyled = styled.div.attrs<ILiteTradeSelectAccountItemStyledProps>(({ selected }) => ({
    className: classNames({ selected })
}))<ILiteTradeSelectAccountItemStyledProps>`
    padding: 16px;
    margin-top: 16px;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: var(--color-button-secondary-default);
    color: var(--color-label-primary);
    cursor: pointer;

    .account-type-icon {
        width: 32px;
        height: 32px;
        fill: var(--color-label-secondary);
        margin-right: 12px;

        background: var(--color-background-primary);
        border-radius: 8px;
        padding: 4px;
        transition: all 500ms;
    }

    span {
        display: inline-block;
    }

    &:hover,
    &.selected {
        background: var(--color-button-secondary-highlight);

        .account-type-icon {
            fill: var(--color-label-accent);
            background: var(--color-background-primary);
        }
    }

    .action-button {
        display: flex;
        align-items: center;
        gap: 4px;
        &.btn.btn-secondary {
            padding: 8px 12px 8px;
        }
        svg {
            fill: var(--color-label-primary);
        }
    }
`;

export const LiteTradeSelectAccountTopUpStyled = styled.div`
    margin-left: auto;
`;

export const LiteTradeSelectAccountButtonStyled = styled.div`
    display: flex;
    align-items: center;
    padding-top: 16px;
    margin-top: 16px;
    position: relative;

    :before {
        content: '';
        display: block;
        width: calc(100% + 32px);
        height: 1px;
        background-color: var(--color-divider-transparent);
        position: absolute;
        top: 0;
        left: -16px
    }
`

interface ISelectAccountToggleStyledProps {
    type: string
}

export const SelectAccountToggleStyled = styled.div.attrs<ISelectAccountToggleStyledProps>(({ type }) => ({
    className: type
}))<ISelectAccountToggleStyledProps>`
    width: 100%;
    .select-toggle {
        padding: 8px 36px 8px 12px;
        background: var(--color-button-secondary-default);
        border-radius: 16px;
        color: var(--color-label-primary);
        border: none;
        line-height: 24px;

        &:hover {
            border-color: transparent;
            color: var(--color-label-secondary);

            .right-icon {
                svg {
                    fill: var(--color-label-secondary);
                }
            }
        }
        
        .right-icon {
            right: 12px;
            font-size: 12px;

            svg {
                fill: var(--color-label-secondary);
            }
        }
    }

    .icon svg {
        width: 32px;
        height: 32px;
        fill: var(--color-label-neutral-primary-black);
        margin-right: 12px;

        background: var(--color-label-accent);
        border-radius: 12px;
        padding: 4px;
    }

    &.demo {
        .select-toggle {
            padding: 4px 36px 4px 4px;
            color: var(--color-label-primary);

            .right-icon {
                svg {
                    fill: var(--color-label-secondary);
                }
            }
        }
    }
`;

export const SelectAccountToggleRowStyled = styled.div`
    flex: 1;
    display: flex;
    justify-content: space-between;
    
    .value {
        color: var(--color-label-primary);
        font-weight: 600;
    }
`;

export const LiteTradeSelectAccountInfoStyled = styled.div`
    display: flex;
    align-items: center;
    margin: 16px 0 0 0;
    
    & svg {
        fill: var(--color-label-secondary);
    }
`;

export const LiteTradeSelectAccountInfoDescriptionStyled = styled.div`
    color: var(--color-label-secondary);
    font-size: 12px;
`;

export const SelectAccountToggle2Styled = styled.div`
    padding: 4px 8px 4px 12px;
    background: transparent;
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--color-label-secondary);
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;

    & .chevron {
        padding: 4px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 12px;
        background: var(--color-button-secondary-default);
    }

    &.filled {
        background: var(--color-background-secondary);
        border-radius: 12px;
        color: var(--color-label-primary);
        padding: 8px 8px 8px 12px;
        
        & .chevron {
            background: transparent;
        }
    }
    
    &.demo {
        color: var(--color-label-accent);
    }
`;